export enum WizardState {
	Create = 'CREATE',
	Edit = 'EDIT',
	Reactivate = 'REACTIVATE',
}
